var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "strix-logo-header-a",
          d:
            "M18.7506477,9.86022216 C19.4406028,9.86022216 20,10.4196194 20,11.1095744 L20,11.1095744 L20,17.2791447 C20,17.9690997 19.4406028,18.528497 18.7506477,18.528497 L18.7506477,18.528497 L5.24887579,18.528497 C4.55892075,18.528497 4,17.9690997 4,17.2791447 L4,17.2791447 L4,11.1095744 C4,10.4196194 4.55892075,9.86022216 5.24887579,9.86022216 C5.93883082,9.86022216 6.49822806,10.4196194 6.49822806,11.1095744 L6.49822806,11.1095744 L6.49822806,16.0302689 L17.5012955,16.0302689 L17.5012955,11.1095744 C17.5012955,10.4196194 18.0606927,9.86022216 18.7506477,9.86022216 Z M11.9287174,6 C12.8302332,6 13.6988713,6.18344799 14.3831085,6.53461985 C14.8338664,6.7685756 15.0678222,7.05208613 15.0678222,7.45328926 C15.0678222,7.97027904 14.7004497,8.37100569 14.1496292,8.37100569 C13.9823818,8.37100569 13.7989339,8.32097442 13.4815927,8.17088061 C12.980327,7.93740135 12.4295065,7.82018523 11.8448554,7.82018523 C11.1272641,7.82018523 10.8266,8.07081807 10.8266,8.45486763 C10.8266,8.82224009 11.0272015,9.02236517 11.9453944,9.12242771 L11.9453944,9.12242771 L12.8302332,9.22296674 C14.7338039,9.4397689 15.5185801,10.3250841 15.5185801,11.6773579 C15.5185801,13.3307722 14.1996605,14.4495667 11.9120403,14.4495667 C10.643152,14.4495667 9.62442002,14.0983948 8.95638345,13.6814676 C8.55565681,13.4308347 8.38840942,13.1301706 8.38840942,12.7461211 C8.38840942,12.2286548 8.82296674,11.8112511 9.3571101,11.8112511 C9.57391227,11.8112511 9.77451383,11.8779594 10.0418238,12.0285297 C10.6259984,12.3620715 11.2440037,12.6127044 12.0287799,12.6127044 C12.8802645,12.6127044 13.2814676,12.3120403 13.2814676,11.8612823 C13.2814676,11.4772328 13.0641889,11.2766312 12.1126418,11.1765687 L12.1126418,11.1765687 L11.2273266,11.0765061 C9.47384973,10.8763811 8.58901099,10.0077429 8.58901099,8.60496143 C8.58901099,7.01873195 9.80786801,6 11.9287174,6 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "xlink:href": "#strix-logo-header-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }